import './App.css'
import { Route } from 'react-router-dom'
import { AppRouter, AuthKeycloak } from '@artprov/design-system'
import { LoaderProvider } from './common/components/loader/loader.component.jsx'
import { AlertProvider } from './common/components/alert/alert.component.jsx'
// import { ClarityProvider, initializeClarity } from './common/utils/context/clarityProvider.jsx'
// import { useMemo } from 'react'
import Nomina from './pages/nomina/nomina.page.jsx'
import NotFound from './pages/not-found/Index.jsx'
import HelpDesk from './pages/help-desk/help-desk.page.jsx'
import Inicio from './pages/productor/inicio.page.jsx'
// import TestPage from './pages/test/test.page.jsx'
import PaginaPublica from './pages/public/Index.jsx'
import { OnboardingPage } from './pages/onboarding/onboarding.page.jsx'
import ProtectedLayout from './common/components/ProtectedLayout.jsx'

function App() {
  // const clarity = useMemo(() => initializeClarity(), [])

  return (
    // <ClarityProvider clarity={clarity}>
    <LoaderProvider>
      <AlertProvider>
        <AppRouter>
          {/* Rutas públicas: fuera del guard de <AuthKeycloak>, accesibles sin sesión.
              AppRouter dispara un checkKeycloakSession silencioso para detectar
              sesión existente y mostrar el dropdown de MiPerfil si corresponde.
              `/onboarding` (registro de nuevos usuarios) se mantiene fuera del
              guard para no forzar login de Keycloak al completar el alta. */}
          <Route path="/public" element={<PaginaPublica />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <AuthKeycloak
            keycloakConfig={{
              url: import.meta.env.VITE_KEYCLOAK_URL,
              realm: import.meta.env.VITE_KEYCLOAK_REALM,
              clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
            }}
            apiConfig={{
              consumidor: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
              services: [
                {
                  name: 'default',
                  baseURL: import.meta.env.VITE_API_BASE_URL,
                },
              ],
            }}
            // accessRole={import.meta.env.VITE_KEYCLOAK_ACCESS_ROLE || 'acceso-demo'}
          >
            {/* Layout de rutas protegidas: restaura la ruta original tras el
                callback OIDC de Keycloak (ver ProtectedLayout). */}
            <Route element={<ProtectedLayout />}>
              {/* <Route path="/" element={<TestPage />} /> */}
              <Route path="/" element={<Inicio />} />
              <Route path="/cargar-nomina/:periodo/:id" element={<Nomina />} />
              <Route path="/cargar-nomina/:periodo/carga" element={<Nomina />} />
              <Route path="/help-desk" element={<HelpDesk />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </AuthKeycloak>
        </AppRouter>
      </AlertProvider>
    </LoaderProvider>
    //  </ClarityProvider>
  )
}

export default App
